import type { Message } from 'google-protobuf'
import type { Metadata, Request, AbstractClientBase, GrpcWebClientBaseOptions, Status, UnaryInterceptor, UnaryResponse, StreamInterceptor } from 'grpc-web';
import { GrpcWebClientBase, MethodDescriptor } from 'grpc-web';

// @ts-ignore
export interface GrpcWebRequest<M = Metadata, REQ extends Message = Message, RESP extends Message = Message> extends Request<REQ, RESP> {
    getRequestMessage(): REQ;
    getMethodDescriptor(): MethodDescriptor<REQ, RESP>;
    getMetadata(): M;
    // getCallOptions(): CallOptions;
}

// @ts-ignore
export interface GrpcWebResponse<M = Metadata, REQ extends Message = Message, RESP extends Message = Message> extends UnaryResponse<REQ, RESP> {
    getResponseMessage(): RESP;
    getMetadata(): M;
    getMethodDescriptor(): MethodDescriptor<REQ, RESP>;
    getStatus(): Status;
}

// @ts-ignore
export interface GrpcWebUnaryInterceptor<M = Metadata, REQ extends Message = Message, RESP extends Message = Message> extends UnaryInterceptor<REQ, RESP> {
    intercept(
        request: GrpcWebRequest<M, REQ, RESP>,
        invoker: (request: GrpcWebRequest<M, REQ, RESP>) => Promise<GrpcWebResponse<M, REQ, RESP>>
    ): Promise<GrpcWebResponse<M, REQ, RESP>>;
}

export interface GrpcWebCallInterceptor<M = Metadata> {
    intercept(req: any, meta: M): void
}

export class GrpcWebMethodDesc<REQ, RESP> extends MethodDescriptor<REQ, RESP> {
    constructor(
        public readonly name: string,
        public readonly methodType: string,
        public readonly requestType: new (...args: unknown[]) => REQ,
        public readonly responseType: new (...args: unknown[]) => RESP,
        public readonly requestSerializeFn: (request: REQ) => Uint8Array,
        public readonly requestDeserializeFn: (bytes: Uint8Array) => REQ,
        public readonly responseSerializeFn: (response: RESP) => Uint8Array,
        public readonly responseDeserializeFn: (bytes: Uint8Array) => RESP
    ) {
        super(name, methodType, requestType, responseType, requestSerializeFn, responseDeserializeFn)
    }
}

/** cf: GrpcWebClientBaseOptions */
interface GrpcWebClientOptions {
    format?: string;
    suppressCorsPreflight?: boolean;
    withCredentials?: boolean;
    
    unaryInterceptors?: GrpcWebUnaryInterceptor<unknown, Message, Message>[];
    streamInterceptors?: StreamInterceptor<unknown, unknown>[];
    callInterceptors?: GrpcWebCallInterceptor<unknown>[];
}

/**
 * If you are using a custom metadata type to add options to the call request and use it in the interceptor,
 * be sure to remove this metadata (headers) before calling the request.
 * You can use AuthorizedHeadersInterceptor for this purpose.
 */
export class GrpcWebClient<META = Metadata> {

    protected client: AbstractClientBase;
    protected callInterceptors: GrpcWebCallInterceptor<META>[] = []

    constructor(protected readonly hostname: string, options: GrpcWebClientOptions = {}) {
        if (!options.format) options.format = 'text';
        if (options.callInterceptors) this.callInterceptors = options.callInterceptors
        this.client = new GrpcWebClientBase(options as GrpcWebClientBaseOptions);
    }
}


/** remove all unauthorized headers */
export class AuthorizedHeadersInterceptor implements GrpcWebUnaryInterceptor {

    constructor(public readonly authorizedHeaders: string[]) { }

    intercept(request: GrpcWebRequest, invoker: (request: GrpcWebRequest) => Promise<GrpcWebResponse>): Promise<GrpcWebResponse> {
        const metadata = request.getMetadata() || {}
        Object.keys(metadata).forEach(k => {
            if (this.authorizedHeaders.indexOf(k) === -1) delete metadata[k]
        })
        return invoker(request)
    }

}

export class EmptyFieldCallInterceptor implements GrpcWebCallInterceptor {

    constructor(
        private headerEmptyArray = "tolemac-empty-array",
        private headerEmptyField = "tolemac-empty-field",
    ) { }

    intercept(req: object, meta: Metadata): void {
        const { emptyArray, emptyField } = findEmpty(req)
        if (emptyArray.length)
            meta[this.headerEmptyArray] = JSON.stringify(emptyArray)
        if (emptyField.length)
            meta[this.headerEmptyField] = JSON.stringify(emptyField)
    }

}

function findEmpty(obj: object): { emptyArray: string[]; emptyField: string[] }
function findEmpty(obj: object, parentKey: string, emptyArray: string[]): void
function findEmpty(obj: object, parentKey = '', emptyArray: string[] = [], emptyField: string[] = []) {
    if (!obj || typeof obj !== 'object')
        return { emptyArray, emptyField }
    for (const k of Object.keys(obj)) {
        const child = obj[k]
        const key = parentKey ? parentKey + '.' + k : k
        if (Array.isArray(child)) {
            if (!child.length && emptyArray.indexOf(key) === -1)
                emptyArray.push(key)
            child.forEach((c, cI) => findEmpty(c, parentKey ? parentKey + '.' + cI + '.' + k : k, emptyArray))
        } else if (child === null || child === undefined) {
            emptyField.push(key)
        } else if (child && typeof child === 'object') {
            findEmpty(child, key, emptyArray)
        }
    }
    if (!parentKey)
        return { emptyArray, emptyField }
}